import { render, staticRenderFns } from "./BookEventSlot.vue?vue&type=template&id=3faeaef1&"
import script from "./BookEventSlot.vue?vue&type=script&lang=js&"
export * from "./BookEventSlot.vue?vue&type=script&lang=js&"
import style0 from "./BookEventSlot.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports